(function() { window.GUID_248ec320_53b5_4ca2_8c72_b857747ced07 = { getGuid: function() { return "248ec320-53b5-4ca2-8c72-b857747ced07"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-csrate",
                        callback: (accordion, e) => {
                            var _a;
                            // const statFieldPalette =
                            //   accordion.$Container
                            //     .find(
                            //       `#CSRateSectionViewModelStatFieldPalette-${accordion.ContentId}`
                            //     )
                            //     ?.val() ?? "";
                            if (accordion.IsExpanded) {
                                accordion.$Content.offon("click.accordionCSRateTabMenuClicked", `#tabmenu-csrate-${accordion.ContentId}`, (e) => {
                                    const $closestTabMenuItem = $(e.target).closest(".tab-menu-item");
                                    if ($closestTabMenuItem.length) {
                                        const { popupUrl } = $closestTabMenuItem.data("html");
                                        if (popupUrl) {
                                            accordion.RefreshContent(() => { }, popupUrl);
                                        }
                                    }
                                });
                                const $statUserGraphsInputs = accordion.$Container.find(`.CSRateSectionViewModelStatUserGraphs-${accordion.ContentId}`);
                                if ($statUserGraphsInputs.length) {
                                    try {
                                        const data = [];
                                        $statUserGraphsInputs.each((index, input) => {
                                            const $input = $(input);
                                            const val = $input.val();
                                            const parsedVal = JSON.parse(val);
                                            const isArray = Array.isArray(parsedVal);
                                            if (isArray) {
                                                data.push(...parsedVal);
                                            }
                                        });
                                        if (data.length) {
                                            const rootId = `${accordion.ContentId}-chart-root`;
                                            const chartContainerHTML = `
                    <div id="${rootId}" class="">
                    </div>
                    `;
                                            const $newChartContainer = accordion.$Container.find(".new-chart-container");
                                            if ($newChartContainer.length) {
                                                let useDivergentPalette = false;
                                                $newChartContainer.append(chartContainerHTML);
                                                const $hasMultipleSymbolsInput = accordion.$Container.find(`.CSRateSectionViewModelHasMultiplePersonas-${accordion.ContentId}`);
                                                const hasMultipleSymbols = $hasMultipleSymbolsInput.length && ((_a = $hasMultipleSymbolsInput.val().toString()) !== null && _a !== void 0 ? _a : "").toLowerCase() == "true";
                                                if (hasMultipleSymbols) {
                                                    useDivergentPalette = true;
                                                }
                                                const lineChart = new CS.Controls.LineChart(rootId, data, undefined, undefined, undefined, undefined, undefined, useDivergentPalette);
                                                lineChart.init().then(() => {
                                                    const $legacyLegendContainer = accordion.$Container.find(".csrate-section__header.custom-chart-persona-legend");
                                                    const $newLegendContainer = accordion.$Container.find(".linechartv2__line-chart__legend");
                                                    if ($legacyLegendContainer.length &&
                                                        $newLegendContainer.length) {
                                                        const $newLegendItems = $newLegendContainer.find(".linechartv2__line-chart__legend-item");
                                                        if ($newLegendItems.length) {
                                                            $newLegendItems.each((index, item) => {
                                                                const $newLegendItem = $(item);
                                                                const symbol = $newLegendItem.attr("data-symbol");
                                                                const $matchingLegacyLegendItem = $legacyLegendContainer.find(`.persona-container[data-id="${symbol}"]`);
                                                                if ($matchingLegacyLegendItem.length) {
                                                                    const $CSRateAccuracy = $matchingLegacyLegendItem.find(".cs-rate-accuracy");
                                                                    if ($CSRateAccuracy.length) {
                                                                        $newLegendItem.append($CSRateAccuracy);
                                                                    }
                                                                    $newLegendItem.append($matchingLegacyLegendItem);
                                                                    $matchingLegacyLegendItem.remove();
                                                                }
                                                            });
                                                        }
                                                        $legacyLegendContainer.remove();
                                                    }
                                                });
                                            }
                                            else {
                                                console.error("No chart container found");
                                            }
                                        }
                                    }
                                    catch (error) {
                                        console.error("Error while parsing stat user graphs", error);
                                    }
                                }
                                // const $dataInput = accordion.$Container.find(
                                //   `#CSRateSectionViewModelData-${accordion.ContentId}`
                                // );
                                // const $useContinuousColorsInput = accordion.$Container.find(
                                //   `#CSRateSectionUseContinuousColors-${accordion.ContentId}`
                                // );
                                // const useContinuousColors = $useContinuousColorsInput.val() == "True";
                                // const chartGradients: Array<{
                                //   key: string;
                                //   gradient: any;
                                // }> = [];
                                // function getGradient(ctx, chartArea, color0, color1) {
                                //   const chartWidth = chartArea.right - chartArea.left;
                                //   const chartHeight = chartArea.bottom - chartArea.top;
                                //   const key = `${chartWidth}-${chartHeight}-${color0}-${color1}`;
                                //   const existingGradient = chartGradients.find((g) => g.key == key);
                                //   if (!existingGradient) {
                                //     const chartGradient = ctx.createLinearGradient(
                                //       0,
                                //       chartArea.bottom,
                                //       0,
                                //       chartArea.top
                                //     );
                                //     chartGradient.addColorStop(0, color0);
                                //     chartGradient.addColorStop(1, color1);
                                //     chartGradients.push({
                                //       key: key,
                                //       gradient: chartGradient,
                                //     });
                                //     return chartGradient;
                                //   }
                                //   return existingGradient.gradient;
                                // }
                                // if ($dataInput.length && $dataInput.val() != null) {
                                //   const data = JSON.parse($dataInput.val()) as {
                                //     MinValue: number;
                                //     MaxValue: number;
                                //     Items: Array<{
                                //       Persona: CS.Controls.ViewModels.PersonaData;
                                //       StatUserGraphs: Array<CS.Controls.ViewModels.ChartValue>;
                                //       CSRate?: number | null;
                                //       CSRateAccuracy?: number | null;
                                //       DefaultTimeFrame: CS.Enumeration.TimeFrame;
                                //     }>;
                                //     Datasets: Array<any>;
                                //     Labels: Array<string>;
                                //     CompareFirstPersonaAgainstTheRest: boolean;
                                //   };
                                //   const canvas = document.getElementById(
                                //     `CSRateSectionViewModelCanvas-${accordion.ContentId}`
                                //   ) as HTMLCanvasElement;
                                //   const context = canvas.getContext("2d");
                                //   let chart: Chart | null = null;
                                //   let colors: string[];
                                //   if (data.CompareFirstPersonaAgainstTheRest) {
                                //     const mainColor =
                                //       Helper.DataVisualizationHelper.CONTINUOUS_PALETTE[500].lightBlue;
                                //     const secondaryColors =
                                //       Helper.DataVisualizationHelper.getStatColors({
                                //         count: data.Datasets.length,
                                //         stat: "CompuSportRating",
                                //       });
                                //     colors = [mainColor, ...secondaryColors];
                                //   } else if (useContinuousColors || data.Datasets.length > 8) {
                                //     // colors = Helper.DataVisualizationHelper.getContinuousColors({
                                //     //     count: data.Datasets.length,
                                //     //     palettes: ["amber", "orange", "deepOrange"],
                                //     // });
                                //     if (statFieldPalette == "Differential") {
                                //       colors = Helper.DataVisualizationHelper.getStatColors({
                                //         count: data.Datasets.length,
                                //         stat: statFieldPalette,
                                //       });
                                //     } else {
                                //       colors = Helper.DataVisualizationHelper.getStatColors({
                                //         count: data.Datasets.length,
                                //         stat: "CompuSportRating",
                                //       });
                                //     }
                                //   } else {
                                //     colors = Helper.DataVisualizationHelper.getColors(
                                //       data.Datasets.length
                                //     );
                                //   }
                                //   let highestDataPointsCount = 0;
                                //   let datasetsMeta = [];
                                //   for (let i = 0; i < data.Datasets.length; i++) {
                                //     const color = `${colors[i]}`;
                                //     datasetsMeta.push({ index: i, color: color, highlighted: false });
                                //     data.Datasets[i].borderColor = `${color}`;
                                //     data.Datasets[i].backgroundColor = `${colors[i]}10`;
                                //     data.Datasets[i].pointBackgroundColor = `${colors[i]}`;
                                //     data.Datasets[i].tension = 0;
                                //     const color0 = `${color}35`;
                                //     const color1 = `${color}05`;
                                //     data.Datasets[i].fill = {
                                //       target: "origin",
                                //       above: data.CompareFirstPersonaAgainstTheRest
                                //         ? color1
                                //         : function (context) {
                                //             const chart = context.chart;
                                //             const { ctx, chartArea } = chart;
                                //             if (!chartArea) {
                                //               return;
                                //             }
                                //             return getGradient(ctx, chartArea, color1, color0);
                                //           },
                                //       below: data.CompareFirstPersonaAgainstTheRest
                                //         ? color1
                                //         : function (context) {
                                //             const chart = context.chart;
                                //             const { ctx, chartArea } = chart;
                                //             if (!chartArea) {
                                //               return;
                                //             }
                                //             return getGradient(ctx, chartArea, color0, color1);
                                //           },
                                //     };
                                //     if (data.Datasets[i].data.length > highestDataPointsCount) {
                                //       highestDataPointsCount = data.Datasets[i].data.length;
                                //     }
                                //     const $personaContainer = accordion.$Container.find(
                                //       `[data-dataset-index="${i}"]`
                                //     );
                                //     if ($personaContainer.length) {
                                //       $personaContainer.css(
                                //         "box-shadow",
                                //         `inset 0 0 100vw 100vw ${colors[i]}20`
                                //       );
                                //       $personaContainer.css("border", `1px solid ${colors[i]}80`);
                                //       const $picHelper = $personaContainer.find(".pic-helper");
                                //       if ($picHelper.length) {
                                //         $picHelper.css("outline", `2px solid ${colors[i]}`);
                                //       }
                                //     }
                                //   }
                                //   // ==================================================================================//
                                //   // =====================// Chart animation
                                //   let animationDuration = 5000;
                                //   const getAnimation = () => {
                                //     return {
                                //       x: {
                                //         type: "number",
                                //         easing: "linear",
                                //         from: NaN, // the point is initially skipped
                                //         delay(ctx) {
                                //           if (ctx.type !== "data" || ctx.xStarted) {
                                //             return 0;
                                //           }
                                //           ctx.xStarted = true;
                                //           return (
                                //             (ctx.index * animationDuration) / ctx.dataset.data.length
                                //           );
                                //         },
                                //       },
                                //       y: {
                                //         type: "number",
                                //         easing: "linear",
                                //         from: (ctx) =>
                                //           ctx.index === 0
                                //             ? ctx.chart.scales.y.getPixelForValue(100)
                                //             : ctx.chart.getDatasetMeta(ctx.datasetIndex).data[
                                //                 ctx.index - 1
                                //               ],
                                //         delay(ctx) {
                                //           if (ctx.type !== "data" || ctx.yStarted) {
                                //             return 0;
                                //           }
                                //           ctx.yStarted = true;
                                //           return (
                                //             (ctx.index * animationDuration) / ctx.dataset.data.length
                                //           );
                                //         },
                                //       },
                                //     };
                                //   };
                                //   // ==================================================================================//
                                //   // =====================// Chart options
                                //   let aspectRatio = CommonData.Current.IsMobileDevice ? 1 : 2;
                                //   //if (
                                //   //    CommonData.Current.Navigation.WallType ==
                                //   //    CS.Enumeration.WallType.PersonaWall
                                //   //) {
                                //   //    aspectRatio = 2;
                                //   //}
                                //   const getOptions = () => {
                                //     return {
                                //       animation: $(
                                //         `#button-csratesectionviewmodelresetanimation-${accordion.ContentId}`
                                //       ).length
                                //         ? getAnimation()
                                //         : undefined,
                                //       responsive: true,
                                //       aspectRatio: aspectRatio,
                                //       maintainAspectRatio: true,
                                //       elements: {
                                //         point: {
                                //           //radius: CommonData.Current.IsMobileDevice ? 0.5 : 1,
                                //           radius: 0.5,
                                //           //hitRadius: CommonData.Current.IsMobileDevice ? 2 : 3,
                                //           hitRadius: CommonData.Current.IsMobileDevice ? 10 : 5,
                                //         },
                                //         line: {
                                //           tension: 0,
                                //           //borderWidth: CommonData.Current.IsMobile ? 1.5 : 1,
                                //           borderWidth: 3,
                                //         },
                                //       },
                                //       interaction: {
                                //         intersect: CommonData.Current.IsMobileDevice ? true : false,
                                //         mode: "nearest",
                                //         axis: "x",
                                //       },
                                //       scales: {
                                //         x: {
                                //           grid: {
                                //             borderColor: "rgba(255,255,255,0.1)",
                                //             color: "rgba(255,255,255,0.025)",
                                //           },
                                //           ticks: {
                                //             color: "rgba(255,255,255,0.5)",
                                //           },
                                //         },
                                //         y: {
                                //           grid: {
                                //             borderColor: "rgba(255,255,255,0.1)",
                                //             color: "rgba(255,255,255,0.025)",
                                //           },
                                //           ticks: {
                                //             color: "white",
                                //           },
                                //           grace: 25,
                                //         },
                                //       },
                                //       plugins: {
                                //         custom_plugin_racing_chart: false,
                                //         legend: {
                                //           display: false,
                                //           labels: {
                                //             color: "white",
                                //             font: {
                                //               family: "'Open Sans', sans-serif",
                                //               style: "italic",
                                //               weight: 600,
                                //             },
                                //           },
                                //         },
                                //         tooltip: {
                                //           itemSort: function (a, b) {
                                //             return b.parsed.y - a.parsed.y;
                                //           },
                                //         },
                                //       },
                                //     };
                                //   };
                                //   // ==================================================================================//
                                //   // =====================// Initialize chart
                                //   let counter = 0;
                                //   const initializeChart = () => {
                                //     if (chart) {
                                //       chart.destroy();
                                //     }
                                //     const datasets = JSON.parse(JSON.stringify(data.Datasets));
                                //     for (let i = 0; i < datasets.length; i++) {
                                //       const color = `${colors[i]}`;
                                //       const color0 = `${color}35`;
                                //       const color1 = `${color}05`;
                                //       datasets[i].fill = {
                                //         target: "origin",
                                //         above: function (context) {
                                //           const chart = context.chart;
                                //           const { ctx, chartArea } = chart;
                                //           if (!chartArea) {
                                //             return;
                                //           }
                                //           return getGradient(ctx, chartArea, color1, color0);
                                //         },
                                //         below: function (context) {
                                //           const chart = context.chart;
                                //           const { ctx, chartArea } = chart;
                                //           if (!chartArea) {
                                //             return;
                                //           }
                                //           return getGradient(ctx, chartArea, color0, color1);
                                //         },
                                //       };
                                //     }
                                //     chart = new Chart(context, {
                                //       type: "line",
                                //       data: {
                                //         labels: data.Labels,
                                //         datasets: datasets,
                                //       },
                                //       options: getOptions(),
                                //     });
                                //     if (counter === 0) {
                                //       counter++;
                                //       Lag(`initialize-chart-${accordion.ContentId}`, 500, () => {
                                //         if (context.canvas.width === 0 || context.canvas.height === 0) {
                                //           counter = 0;
                                //           initializeChart();
                                //         }
                                //       });
                                //     }
                                //   };
                                //   initializeChart();
                                //   const horizontalBarChartContainerId = `CSRateSectionViewModelCompareHorizontalBarChart-${accordion.ContentId}`;
                                //   const horizontalBarChartContainer = document.getElementById(
                                //     horizontalBarChartContainerId
                                //   );
                                //   if (horizontalBarChartContainer) {
                                //     let valueA = NaN;
                                //     let valueB = NaN;
                                //     const _valueA =
                                //       horizontalBarChartContainer.attributes["data-value-a"]?.value ??
                                //       "";
                                //     const _valueB =
                                //       horizontalBarChartContainer.attributes["data-value-b"]?.value ??
                                //       "";
                                //     let shouldRenderChart = true;
                                //     if (
                                //       Helper.isNullOrWhiteSpace(_valueA) ||
                                //       Helper.isNullOrWhiteSpace(_valueB)
                                //     ) {
                                //       shouldRenderChart = false;
                                //     }
                                //     try {
                                //       valueA = Number(_valueA);
                                //       valueB = Number(_valueB);
                                //     } catch (error) {
                                //       shouldRenderChart = false;
                                //       console.log(error);
                                //     }
                                //     shouldRenderChart = !isNaN(valueA) && !isNaN(valueB);
                                //     const $homeOddsOfWinning = accordion.$Container.find(
                                //       `#CSRateSectionHomeOddsOfWiningOneGame-${accordion.ContentId}`
                                //     );
                                //     const $awayOddsOfWinning = accordion.$Container.find(
                                //       `#CSRateSectionAwayOddsOfWiningOneGame-${accordion.ContentId}`
                                //     );
                                //     if ($homeOddsOfWinning.length && $awayOddsOfWinning.length) {
                                //       try {
                                //         const homeOddsOfWinning = Number($homeOddsOfWinning.val());
                                //         const awayOddsOfWinning = Number($awayOddsOfWinning.val());
                                //         if (!isNaN(homeOddsOfWinning) && !isNaN(awayOddsOfWinning)) {
                                //           valueA = homeOddsOfWinning;
                                //           valueB = awayOddsOfWinning;
                                //         }
                                //       } catch (error) {
                                //         console.log(error);
                                //       }
                                //     }
                                //     if (shouldRenderChart) {
                                //       horizontalBarChartContainer.style.marginTop = "8px";
                                //       horizontalBarChartContainer.style.marginBottom = "32px";
                                //       horizontalBarChartContainer.style.position = "relative";
                                //       // Append a vertical line in the center of the container
                                //       const $legends = accordion.$Container.find(
                                //         ".custom-chart-persona-legend.grid"
                                //       );
                                //       $legends.css({
                                //         justifyContent: "space-between",
                                //       });
                                //       const datapoints: CS.Controls.ComparedValueBarChartDatapoint[] = [
                                //         {
                                //           stackId: "0",
                                //           seriesId: "A",
                                //           value: valueA,
                                //           isStacked: false,
                                //         },
                                //         {
                                //           stackId: "0",
                                //           seriesId: "B",
                                //           value: valueB,
                                //           isStacked: true,
                                //         },
                                //       ];
                                //       const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                                //       const comparedValueBarChart =
                                //         new CS.Controls.ComparedValueBarChart({
                                //           containerElementId: horizontalBarChartContainerId,
                                //           colors: colors,
                                //           datapoints: datapoints,
                                //         });
                                //       comparedValueBarChart
                                //         .init()
                                //         .then(() => {
                                //           console.log("ComparedValueBarChart.init() done");
                                //         })
                                //         .catch((error) => {
                                //           console.log("ComparedValueBarChart.init() error", error);
                                //         });
                                //     }
                                //   }
                                //   // ==================================================================================//
                                //   // =====================// Highlight a persona
                                //   accordion.$Container.offon(
                                //     "click.personacontainerclickedcsr",
                                //     ".persona-container",
                                //     (e) => {
                                //       const $personaContainer = $(e.currentTarget);
                                //       const datasetIndex = $personaContainer.data("dataset-index");
                                //       const clickedDatasetMeta = datasetsMeta.find(
                                //         (meta) => meta.index === datasetIndex
                                //       );
                                //       if (clickedDatasetMeta.highlighted) {
                                //         const anyOtherHighlighted = datasetsMeta.find(
                                //           (meta) => meta.highlighted && meta.index !== datasetIndex
                                //         );
                                //         if (anyOtherHighlighted) {
                                //           chart.data.datasets.forEach((dataset, index) => {
                                //             const datasetMeta = datasetsMeta.find(
                                //               (meta) => meta.index === index
                                //             );
                                //             if (index === datasetIndex) {
                                //               clickedDatasetMeta.highlighted = false;
                                //             }
                                //             const color = datasetsMeta.find(
                                //               (meta) => meta.index === index
                                //             ).color;
                                //             const $datasetPersonaContainer = accordion.$Container.find(
                                //               `[data-dataset-index="${index}"]`
                                //             );
                                //             if (datasetMeta.highlighted) {
                                //               dataset.borderColor = `${color}`;
                                //               dataset.pointBackgroundColor = `${color}`;
                                //               dataset.backgroundColor = `${color}10`;
                                //               const color0 = `${color}35`;
                                //               const color1 = `${color}05`;
                                //               dataset.fill = {
                                //                 target: "origin",
                                //                 above: function (context) {
                                //                   const chart = context.chart;
                                //                   const { ctx, chartArea } = chart;
                                //                   if (!chartArea) {
                                //                     return;
                                //                   }
                                //                   return getGradient(ctx, chartArea, color1, color0);
                                //                 },
                                //                 below: function (context) {
                                //                   const chart = context.chart;
                                //                   const { ctx, chartArea } = chart;
                                //                   if (!chartArea) {
                                //                     return;
                                //                   }
                                //                   return getGradient(ctx, chartArea, color0, color1);
                                //                 },
                                //               };
                                //               data.Datasets[index].borderColor = `${color}`;
                                //               data.Datasets[index].pointBackgroundColor = `${color}`;
                                //               data.Datasets[index].backgroundColor = `${color}10`;
                                //               $datasetPersonaContainer.css("opacity", 1);
                                //               $datasetPersonaContainer.css(
                                //                 "border",
                                //                 `1px solid ${color}`
                                //               );
                                //             } else {
                                //               dataset.borderColor = `${color}15`;
                                //               dataset.pointBackgroundColor = `${color}15`;
                                //               dataset.backgroundColor = `${color}02`;
                                //               data.Datasets[index].borderColor = `${color}15`;
                                //               data.Datasets[index].pointBackgroundColor = `${color}15`;
                                //               data.Datasets[index].backgroundColor = `${color}02`;
                                //               $datasetPersonaContainer.css("opacity", 0.5);
                                //               $datasetPersonaContainer.css(
                                //                 "border",
                                //                 `1px solid ${color}50`
                                //               );
                                //               const color0 = `${color}10`;
                                //               const color1 = `${color}01`;
                                //               dataset.fill = {
                                //                 target: "origin",
                                //                 above: function (context) {
                                //                   const chart = context.chart;
                                //                   const { ctx, chartArea } = chart;
                                //                   if (!chartArea) {
                                //                     return;
                                //                   }
                                //                   return getGradient(ctx, chartArea, color1, color0);
                                //                 },
                                //                 below: function (context) {
                                //                   const chart = context.chart;
                                //                   const { ctx, chartArea } = chart;
                                //                   if (!chartArea) {
                                //                     return;
                                //                   }
                                //                   return getGradient(ctx, chartArea, color0, color1);
                                //                 },
                                //               };
                                //             }
                                //           });
                                //         } else {
                                //           chart.data.datasets.forEach((dataset, index) => {
                                //             const datasetMeta = datasetsMeta.find(
                                //               (meta) => meta.index === index
                                //             );
                                //             if (index === datasetIndex) {
                                //               clickedDatasetMeta.highlighted = false;
                                //             } else {
                                //               datasetMeta.highlighted = false;
                                //             }
                                //             const color = datasetsMeta.find(
                                //               (meta) => meta.index === index
                                //             ).color;
                                //             dataset.borderColor = `${color}`;
                                //             dataset.pointBackgroundColor = `${color}`;
                                //             dataset.backgroundColor = `${color}10`;
                                //             data.Datasets[index].borderColor = `${color}`;
                                //             data.Datasets[index].pointBackgroundColor = `${color}`;
                                //             data.Datasets[index].backgroundColor = `${color}10`;
                                //             const $datasetPersonaContainer = accordion.$Container.find(
                                //               `[data-dataset-index="${index}"]`
                                //             );
                                //             $datasetPersonaContainer.css("opacity", 1);
                                //             $datasetPersonaContainer.css(
                                //               "border",
                                //               `1px solid ${color}80`
                                //             );
                                //             const color0 = `${color}35`;
                                //             const color1 = `${color}05`;
                                //             dataset.fill = {
                                //               target: "origin",
                                //               above: function (context) {
                                //                 const chart = context.chart;
                                //                 const { ctx, chartArea } = chart;
                                //                 if (!chartArea) {
                                //                   return;
                                //                 }
                                //                 return getGradient(ctx, chartArea, color1, color0);
                                //               },
                                //               below: function (context) {
                                //                 const chart = context.chart;
                                //                 const { ctx, chartArea } = chart;
                                //                 if (!chartArea) {
                                //                   return;
                                //                 }
                                //                 return getGradient(ctx, chartArea, color0, color1);
                                //               },
                                //             };
                                //           });
                                //         }
                                //       } else {
                                //         chart.data.datasets.forEach((dataset, index) => {
                                //           const color = datasetsMeta.find(
                                //             (meta) => meta.index === index
                                //           ).color;
                                //           const datasetMeta = datasetsMeta.find(
                                //             (meta) => meta.index === index
                                //           );
                                //           if (index === datasetIndex) {
                                //             dataset.borderColor = `${color}`;
                                //             dataset.pointBackgroundColor = `${color}`;
                                //             dataset.backgroundColor = `${color}10`;
                                //             data.Datasets[index].borderColor = `${color}`;
                                //             data.Datasets[index].pointBackgroundColor = `${color}`;
                                //             data.Datasets[index].backgroundColor = `${color}10`;
                                //             clickedDatasetMeta.highlighted = true;
                                //             $personaContainer.css("opacity", 1);
                                //             $personaContainer.css("border", `1px solid ${color}`);
                                //             const color0 = `${color}35`;
                                //             const color1 = `${color}05`;
                                //             dataset.fill = {
                                //               target: "origin",
                                //               above: function (context) {
                                //                 const chart = context.chart;
                                //                 const { ctx, chartArea } = chart;
                                //                 if (!chartArea) {
                                //                   return;
                                //                 }
                                //                 return getGradient(ctx, chartArea, color1, color0);
                                //               },
                                //               below: function (context) {
                                //                 const chart = context.chart;
                                //                 const { ctx, chartArea } = chart;
                                //                 if (!chartArea) {
                                //                   return;
                                //                 }
                                //                 return getGradient(ctx, chartArea, color0, color1);
                                //               },
                                //             };
                                //           } else {
                                //             if (!datasetMeta.highlighted) {
                                //               dataset.borderColor = `${color}15`;
                                //               dataset.pointBackgroundColor = `${color}15`;
                                //               dataset.backgroundColor = `${color}02`;
                                //               data.Datasets[index].borderColor = `${color}15`;
                                //               data.Datasets[index].pointBackgroundColor = `${color}15`;
                                //               data.Datasets[index].backgroundColor = `${color}02`;
                                //               datasetMeta.highlighted = false;
                                //               const $datasetPersonaContainer =
                                //                 accordion.$Container.find(
                                //                   `[data-dataset-index="${index}"]`
                                //                 );
                                //               $datasetPersonaContainer.css("opacity", 0.5);
                                //               $datasetPersonaContainer.css(
                                //                 "border",
                                //                 `1px solid ${color}80`
                                //               );
                                //               const color0 = `${color}10`;
                                //               const color1 = `${color}01`;
                                //               dataset.fill = {
                                //                 target: "origin",
                                //                 above: function (context) {
                                //                   const chart = context.chart;
                                //                   const { ctx, chartArea } = chart;
                                //                   if (!chartArea) {
                                //                     return;
                                //                   }
                                //                   return getGradient(ctx, chartArea, color1, color0);
                                //                 },
                                //                 below: function (context) {
                                //                   const chart = context.chart;
                                //                   const { ctx, chartArea } = chart;
                                //                   if (!chartArea) {
                                //                     return;
                                //                   }
                                //                   return getGradient(ctx, chartArea, color0, color1);
                                //                 },
                                //               };
                                //             }
                                //           }
                                //         });
                                //       }
                                //       chart.update();
                                //     }
                                //   );
                                //   // ==================================================================================//
                                //   // =====================// Update chart
                                //   accordion.$Container.offon(
                                //     "click.personacontainerclickedcsr2",
                                //     `#button-csratesectionviewmodelresetanimation-${accordion.ContentId}`,
                                //     (e) => {
                                //       chart.destroy();
                                //       initializeChart();
                                //     }
                                //   );
                                //   accordion.$Container.offon(
                                //     "click.personacontainerclickedcsr3",
                                //     `#button-csratesectionviewmodelslower-${accordion.ContentId}`,
                                //     (e) => {
                                //       if (animationDuration < 10000) {
                                //         animationDuration += 1000;
                                //         chart.destroy();
                                //         initializeChart();
                                //       }
                                //     }
                                //   );
                                //   accordion.$Container.offon(
                                //     "click.personacontainerclickedcsr4",
                                //     `#button-csratesectionviewmodelfaster-${accordion.ContentId}`,
                                //     (e) => {
                                //       if (animationDuration > 1000) {
                                //         animationDuration -= 1000;
                                //         chart.destroy();
                                //         initializeChart();
                                //       }
                                //     }
                                //   );
                                // }
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.js.map
